import { useCallback, useState, useEffect } from "react";
import { InputStyled } from "./style-component";
import CustomButton from "@/components/custom-button/custom-button";
import { InputActionProps } from "./input-action-type";
import AtIcon from "@/assets/icons/at-icon/at-icon.svg";
import { useTheme } from "styled-components";

const defaultValidations = [
  (val:string) => val.trim() === "" && "Debes ingresar un dato válido",
  (val:string) => val.includes(" ") && "No se permiten espacios en el usuario o URL",
];

const InputAction: React.FC<InputActionProps> = ({ 
  textButton = "Buscar",
  name = 'text',
  placeholder = 'Enter value',
  validations = defaultValidations,
  value = '',
  setValue,
  onExecute= (_value:string) => {},
  loading = false
}) => {
  const [error, setError] = useState("");
  const [isValid, setIsValid] = useState<boolean>(false);
  const [touched, setTouched] = useState(false);

  const isUrl = value.startsWith('http');
  const theme = useTheme();

  const validateInput = useCallback((input:string) => {
    for (const validate of [...defaultValidations, ...(validations || [])]) {
      const errorMsg = validate(input);
      if (errorMsg) {
        setIsValid(false);
        setError(errorMsg);
        return;
      }
    }
    setIsValid(true);
    setError("");
  }, [validations]);

  useEffect(() => {
    validateInput(value);
  }, [value, validateInput]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const cleanValue = inputValue.startsWith('@') ? inputValue.slice(1) : inputValue;
    setTouched(true);
    setValue?.(cleanValue);    
  };

  const handleSubmit = useCallback((e: React.ChangeEvent<HTMLFormElement>)=>{
    e?.preventDefault();
    if (isValid) {
      onExecute?.(value);
    }
  }, [value, onExecute, isValid])

  return ( 
    <form onSubmit={handleSubmit} style={{ width: '100%'}}>
      <InputStyled>
        {!isUrl && (
          <img 
            src={AtIcon} 
            alt="at-icon" 
            style={{ 
              width: '18px', 
              height: '18px',
              filter: theme?.name === 'dark' ? 'none' : 'invert(1)',
              marginLeft: '4px'
            }}
          />
        )}
        <input 
          data-testid={"username-input"}
          name={name}
          value={value} 
          onChange={handleChange}
          placeholder={placeholder} 
          autoComplete="off"
          disabled={loading}
          type="search"
        />
        <CustomButton 
          data-testid={"button-submit"}
          disabled={!isValid || loading}
          style={{ padding: '4px 16px', width:'auto'}} 
          type="primary"
          htmlType="submit"
        >
          {textButton}
        </CustomButton>
      </InputStyled>
      {touched && error && <span data-testid={"error-message"} style={{ color: "red", fontSize: "12px" }}>{error}</span>}
    </form>
  );
};

export default InputAction;